import { pca, apiScopes } from './msalConfig'
import { getOtpToken } from './otp/otpActions'

export async function acquireApiToken(): Promise<string> {
  const account = pca.getActiveAccount() ?? pca.getAllAccounts()[0]
  // Kein MSAL-Account ⇒ E-Mail-OTP-Fallback (V1.14): wenn ein OTP-Session-Token
  // vorliegt, wird es als Bearer verwendet. Entra bleibt der bevorzugte Weg.
  if (!account) {
    const otp = getOtpToken()
    if (otp) return otp
    throw new Error('no-account')
  }
  try {
    const res = await pca.acquireTokenSilent({ scopes: apiScopes, account })
    return res.accessToken
  } catch {
    // #172: the silent renewal failed for an existing account — the session is dead
    // (refresh token expired after days idle, hidden-iframe renewal timed out, etc.).
    // The specific MSAL error class does NOT matter: InteractionRequiredAuthError,
    // BrowserAuthError ("monitor_window_timeout", "interaction_in_progress"),
    // ClientAuthError — ALL of them must recover the same way. Re-throwing (the old
    // behaviour, which only special-cased InteractionRequired) surfaced a generic error
    // that dead-ended the app at /denied and only a full cache wipe fixed it.
    // Recover with a full-page interactive redirect — never a popup (blocked on
    // auto-load). The returned promise never resolves because the browser navigates
    // away; a fresh token is available after the redirect round-trip.
    try {
      await pca.acquireTokenRedirect({ scopes: apiScopes, account })
      // The browser is navigating away — never resolve.
      return new Promise<string>(() => {})
    } catch {
      // The redirect could not start. Typically a stale "interaction_in_progress" flag
      // left over from an aborted interaction: LoginRedirect guards against this by
      // waiting for InteractionStatus.None, but a token request cannot wait. Do NOT sit
      // on a never-resolving promise here — that showed as a permanent "Lädt…" that only
      // cleared after several reloads. Recover deterministically instead: drop the dead
      // MSAL state and reload into the clean login path, which starts the interactive
      // login once MSAL is idle. After the reload there is no account, so this cannot loop.
      try {
        await pca.clearCache()
      } catch {
        // best effort — the reload below is what actually breaks the deadlock
      }
      window.location.assign('/')
      return new Promise<string>(() => {})
    }
  }
}
